import type { AccountPersona } from '@/api/types';

/** Public signup selects a product; the backend owns its initial tier. */
export const SIGNUP_PRODUCTS = ['monotributo', 'responsable-inscripto', 'estudio', 'api'] as const;
export type SignupProduct = typeof SIGNUP_PRODUCTS[number];

export function parseSignupProduct(value: unknown): SignupProduct | undefined {
  return SIGNUP_PRODUCTS.find((product) => product === value);
}

export const SIGNUP_ROLE = {
  monotributo: 'mono',
  'responsable-inscripto': 'ri',
  estudio: 'contador',
  api: 'dev',
} as const;

export interface InitialOnboardingCopy {
  heading: string;
  subtitle: string;
  firstStep: string;
  activityTitle: string;
}

export function initialOnboardingCopy(persona: AccountPersona | undefined): InitialOnboardingCopy {
  switch (persona) {
    case 'ResponsableInscripto':
      return {
        heading: 'Configurá Responsable Inscripto en Tilde',
        subtitle: 'Vamos a registrar tu CUIT y dejar listo el circuito para emitir y trabajar el IVA mensual.',
        firstStep: 'Registrar CUIT RI',
        activityTitle: 'Datos de tu actividad como Responsable Inscripto',
      };
    case 'Contador':
      return {
        heading: 'Configurá tu Estudio Contable en Tilde',
        subtitle: 'Vamos a registrar el CUIT del estudio y dejar lista tu cartera para sumar clientes.',
        firstStep: 'Registrar CUIT del estudio',
        activityTitle: 'Datos del estudio',
      };
    case 'Developer':
      return {
        heading: 'Configurá API para Programadores',
        subtitle: 'Empezá en Sandbox y prepará la aplicación, credenciales y circuito productivo.',
        firstStep: 'Crear aplicación',
        activityTitle: 'Datos de la integración',
      };
    default:
      return {
        heading: 'Configurá Monotributo en Tilde',
        subtitle: 'Vamos a configurar tu único CUIT en tres pasos.',
        firstStep: 'Registrar CUIT',
        activityTitle: 'Datos de tu actividad',
      };
  }
}
